const axios = require('axios');

export function getDepotCode(zipCode, address) {
  return new Promise(function(resolve, reject) {
    console.log("getDepotCode");
    // console.log('https://koapi.utasco.net/get_depot_code.php?zipCode='+ zipCode + "&address=" + address);
    // let url = process.env.APP_URL + 'api/get_depot_code.php?zipCode='+ zipCode + "&address=" + address;
    let url = 'https://posapi.boriumstudio.com/get_depot_code.php?zipCode='+ zipCode + "&address=" + address;
    console.log(url);
    axios.get(url)
      .then(function(response) {
        console.log(response);
        let data = response.data;
        resolve(data);
      })
      .catch(function(error) {
        reject(error);
      })
  })
}


export function requestPrintLabel(cdList, item, extra = " ", printerUrl = false) {
  return new Promise(function(resolve, reject) {
    console.log("requestPrintLabel");
    console.log(cdList);
    let string = "";
    let awb = item.awb;
    string += "awb="+ awb;
    let code1 = " ";
    if(cdList.delivAreaCd != null && cdList.delivAreaCd.length > 1) {
      code1 = cdList.delivAreaCd.substr(0, 2);
    }
    string += "&code1="+ code1;
    let code2 = " ";
    if(cdList.arrCnpoNm != null && cdList.arrCnpoNm.length > 1) {
      code2 = cdList.arrCnpoNm;
    }
    string += "&code2="+ code2;

    let code3 = " ";
    if(cdList.delivAreaCd != null && cdList.delivAreaCd.length > 1) {
      code3 = cdList.delivAreaCd.substr(2, 3);
    }

    console.log("code3=" + code3);
    string += "&code3="+ code3;
    let code4 = " ";
    if(cdList.delivPoNm != null && cdList.delivPoNm.length > 1) {
      code4 = cdList.delivPoNm;
    }
    string += "&code4="+ code4;


    let code5 = " ";
    let code6 = " ";
    if(cdList.delivAreaCd != null && cdList.delivAreaCd.length > 1) {
      code5 = cdList.delivAreaCd.substr(5, 2);
      code6 = cdList.delivAreaCd.substr(7, 2);
    }
    console.log("code5=" + code5);
    string += "&code5="+ code5;
    string += "&code6="+ code6;
    let zipCode = item.post_code;
    string += "&zipCode="+ zipCode;
    let sender = item.sender;
    if(sender.includes('&')) {
      sender = sender.replace('&', '\\' + encodeURIComponent('&'));
    }
    string += "&sender="+ sender;
    let senderAddress = item.sender_address_1;
    if(item.sender_address_2.length > 0) {
      senderAddress += " " + item.sender_address_2;
    }


    console.log("senderAddress " + senderAddress);
    string += "&senderAddress="+ senderAddress;
    let receiver = item.receiver;
    string += "&receiver="+ receiver;
    let address = item.address_1;
    if(item.address_2.length > 0) {
      address += ' ' + item.address_2;
    }

    if(address.includes('"')) {
      address = address.replace('"', '\"');
    }
    if(address.includes("'")) {
      address = address.replace("'", "\'");
    }
    if(address.includes("`")) {
      address = address.replace("`", "");
    }
    if(address.includes("샾")) {
      address = address.replace("샾", "샵");
    }
    if(address.includes("숖")) {
      address = address.replace("숖", "숍");
    }

    let address2 = '';
    let address1 = address;
    if(address.length > 31) {
      let pos = 30;
      for(let i = 30 ; i > 25 ; i--) {
        if(address[i] === ' ') {
          pos = i;
          break;
        }
      }
      address2 = address.substring(pos);
      address1 = address.substring(0, pos);

    }
    // let addresses = address.match(/.{1,18}/g);
    //
    // address = addresses.join('                ');
    string += "&address="+ address1;
    if(address2 !== '') {
      string += "&address2=" + address2;
    }
    let product = "";
    if(item.list.length > 0) {
      for(let i = 0 ; i < item.list.length ; i++) {
        product += " " + item.list[i].product;
      }
    }
    if(item.note != "") {

      if(item.note.includes("샾")) {
        item.note = item.note.replace("샾", "샵");
      }
      if(item.note.includes("숖")) {
        item.note = item.note.replace("숖", "숍");
      }
      item.note = item.note.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');

      string += "&product="+ item.note;
    } else {
      string += "&product=메모";
    }
    string += "&extra=" + extra;
    //string += "&product="+ product;
    let contact = item.receiver_contact;
    string += "&contact="+ contact;
    if(printerUrl == false) {
      printerUrl = process.env.PRINTER_URL;
    }
    console.log("print job " + printerUrl + '?' + string);
    axios.get(printerUrl + '?' + string)
      .then(function(response){
        console.log(response);
        resolve(response);
      })
      .catch(function(err){
        console.log(err);
        reject(err);
      })
  })
}
export function printHouseLabel(consignee, addr1, addr2, addr3, totalPieces, mawb, hawb, hawbpcs, count) {
  console.log("print label");
  return new Promise(function(resolve, reject) {
    let  printerUrl = process.env.LABEL_PRINTER_URL;


    let url = printerUrl + "?consignee=" + consignee + "&addr1=" + addr1 + "&addr2=" + addr2 + "&addr3=" + addr3 + "&totalPieces=" + totalPieces + "&mawb=" + mawb + "&hawb=" + hawb + "&hawbpcs=" + hawbpcs;
    url += "&count=" + count;
    console.log(printerUrl);
    axios.get(url)
      .then(function(response){
        console.log(response);
        resolve(response);
      })
      .catch(function(err){
        console.log(err);
        reject(err);
      })

  })
}



// WEBPACK FOOTER //
// ./src/api/parcel.js